/** @file       SmithUserContent.jsx
 *  @author     Robert Mirandola <robert@distributive.network>
 * 
 *  @date       April 2022
 *
 *              User content for displaying and managing user info for the Smith School Portal
 */

import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function SmithUserContent(_props) {
  const { t } = useTranslation();
  return (
    <div className='smith_rs_userContent'>
      <h2>For Assistance</h2>
      <p>
      If you require assistance, you can contact us by email at <a href="mailto:info@distributive.network">info@distributive.network</a> with any questions.
      </p>
      <h2>Policies</h2>
      <p>
        Follow these links for our&nbsp;
        <NavLink to='/policy'>
          <strong>{t('privacy_policy')}</strong>
        </NavLink>
        &nbsp;and our&nbsp;
        <NavLink to='/tos'>
          <strong>{t('terms_of_service')}</strong>
        </NavLink>.
      </p>
    </div>
  )
}
